"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressPickerWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AddressPickerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AddressPickerstyle__AddressPickerWrapper",
  componentId: "sc-fy1d7m-0"
})(function () {
  return [];
});
exports.AddressPickerWrapper = AddressPickerWrapper;
//# sourceMappingURL=AddressPicker.style.js.map